<template>
    <ob1-popin-modal2 :id="modalId" :aria-labelledby="titleId">
        <h2 :id="titleId" class="visually-hidden">
            Détail du financement {{ deviceName }}
        </h2>
        <ob1-page-menu
            v-if="displayPxf && displayCb4x"
            :tabs="getTabs()"
            is-tablist
            class="mb-3"
            @ob1-page-menu-click="switchTab"
        />
        <div
            v-show="displayCb4xContent"
            id="4xcb-panel"
            role="tabpanel"
            aria-labelledby="4xcb-tab"
        >
            <slot name="cb4x-content" />
        </div>
        <div
            v-show="!displayCb4xContent"
            id="pxf-panel"
            role="tabpanel"
            aria-labelledby="pxf-tab"
        >
            <slot name="pxf-content" />
        </div>
    </ob1-popin-modal2>
</template>
<script>

export default {
    name: 'PxfCb4xModal',
    props: {
        modalId: {
            type: String,
            required: true
        },
        deviceName: {
            type: String,
            required: false,
            default: null
        },
        displayCb4x: {
            type: Boolean,
            required: true
        },
        displayPxf: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            displayCb4xContent: this.displayCb4x && !this.displayPxf
        }
    },
    computed: {
        titleId() {
            return this.modalId + '-title';
        }
    },
    mounted() {
        const _this = this
        $('#popin-pxf-4xcb').on('hide.bs.modal', function () {
            Tms.link({category: "popin_financement", action: _this.getAction(), label: "popin_ferme"})
        });
        $(`#${this.modalId}`).on("show.bs.modal", () => {
            this.displayCb4xContent = this.displayCb4x && !this.displayPxf
            // On replie tous les liens de la faq à l'initialisation de la popin
            if (this.displayCb4x && document.querySelector('#cb4x-content-faq')) {
                document.querySelector('#cb4x-content-faq').childNodes.forEach((_item, index) => {
                    $('#cb4x-content-faq' + index).collapse('hide');
                });
            }
            if (this.displayPxf && document.querySelector('#pxf-content-faq')) {
                document.querySelector('#pxf-content-faq').childNodes.forEach((_item, index) => {
                    $('#pxf-content-faq' + index).collapse('hide');
                });
            }
        });
    },
    methods: {
        switchTab(id) {
            this.displayCb4xContent = id === '4xcb-tab'
            Tms.link({category: "popin_financement", action: this.getAction(), label: "popin_ouverte"})
        },
        getAction() {
            if (this.displayCb4xContent) {
               return "voir_nos_solutions_de_financement_en_4_fois"
            } else {
                return "voir_nos_solutions_de_financement_en_12_fois"
            }
        },
        getTabs(){
            return [
                {
                    id: "pxf-tab",
                    label: "Payez en 12 fois et +",
                    isActive: !this.displayCb4xContent,
                    controls: "pxf-panel"
                },
                {
                    id: "4xcb-tab",
                    label: "Payez en 4 fois",
                    isActive: this.displayCb4xContent,
                    controls: "4xcb-panel"
                },
            ]
        }
    }
}
</script>

<style lang="scss">
</style>
